import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnSB: CultureInfo = {
  name: 'en-SB',
  displayName: 'English (Solomon Islands)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-SB',
  parent: CultureInfoEn
};
